<template>
  <div class="accodion_box accodion_total">
    <div class="accodion_box_tit">
      <a href="#target_total" data-toggle="collapse" aria-expanded="true">
        <div class="panel-title">
          <span class="text-uppercase accordion-header-text">결제금액</span>
          <!-- 툴팁 -->
          <div class="toolTip-wrapper toolTip-type02 type-mob-full" :class="toolTipOpen ? 'open' : ''">
            <button type="button" class="btn-tooltip" @click.stop.prevent="toolTipOpen = !toolTipOpen;">
              <span class="hidden">안내</span></button>
            <div class="tipCont-wrapper">
              <div class="tooltip-content" :style="toolTipOpen ? { display: 'block' } : { display: 'none'}">
                <div
                  class="box_row-info"
                  v-for="(pack, index) in packs"
                  :key="index"
                >
                  <p class="txt_total-title">{{ `${index + 1}. ${pack.packName}` }}</p>
                  <p class="txt_total-info">{{ pack.amounts.price }}원 PV/BV {{ pack.amounts.pv }}/{{ pack.amounts.bv }}</p>
                </div>
              </div>
            </div>
          </div>
          <span class="pull-right icon-arr" />
        </div>
      </a>
    </div>
    <div
      id="target_total"
      class="accodion_box_cont0 collapse in"
      aria-expanded="true"
    >
      <div class="accodion_box_cont">
        <div class="box_cart-info">
          <div class="box_row-group">
            <div class="box_row-info">
              <p class="txt_total-title">주문금액</p>
              <p class="txt_total-info">{{ totalPaymentInfo.orderPrice }}원</p>
            </div>
            <div class="box_row-info">
              <p class="txt_total-title">배송비</p>
              <p class="txt_total-info">{{ totalPaymentInfo.deliveryFee }}원</p>
            </div>
            <div class="box_row-info">
              <p class="txt_total-title">포장비</p>
              <p class="txt_total-info">{{ totalPaymentInfo.packagingFee }}원</p>
            </div>
            <div class="box_row-info">
              <p class="txt_total-title">할인정보</p>
              <p class="txt_total-info">{{ totalPaymentInfo.totalDiscount }}원</p>
            </div>
          </div>
          <div class="box_row-info box_price">
            <p class="txt_total-title">총 결제금액</p>

            <p class="txt_total-info">{{ totalPaymentInfo.totalPrice }}원</p>
          </div>
          <div class="box_row-info box_total">
            <p class="txt_total-title">총 PV/BV</p>
            <p class="txt_total-info">
              <span class="text_price-pv">{{ totalPaymentInfo.totalPv }} /</span>
              <span class="text_price-bv">{{ totalPaymentInfo.totalBv }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "OrderSummary",
  computed: {
  },
  data() {
    return {
      toolTipOpen: false,
    }
  },
  props: {
    packs: {
      type: Array,
      required: true,
      default: () => {
        return [
          {
            packName: "마이팩",
            amounts: {
              price: 150000,
              pv: 1500,
              bv: 1500
            }
          }
        ]
      }
    },
    totalPaymentInfo: {
      type: Object,
      required: true,
      default: () => {
        return {
          totalPrice: 150000,
          totalPv: 1500,
          totalBv: 1500,
          totalDiscount: 0,
          orderPrice: 0,
          deliveryFee: 0,
          packagingFee: 0
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
